// "ResizeObserver loop ..." là cảnh báo VÔ HẠI của trình duyệt khi layout đổi
// kích thước trong lúc AntD re-render (đổi theme, night mode, mở dropdown...).
// Overlay dev của webpack/CRA bắt window 'error' này và hiện như một crash.
// Ở đây chặn riêng lỗi đó lại và ẩn overlay — KHÔNG che các lỗi thật khác.

const RESIZE_OBSERVER_MESSAGES = [
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications.',
];

const isResizeObserverError = (message?: string): boolean =>
  !!message && RESIZE_OBSERVER_MESSAGES.some((m) => message.includes(m));

const hideWebpackOverlay = (): void => {
  const overlay = document.getElementById('webpack-dev-server-client-overlay');
  const overlayDiv = document.getElementById('webpack-dev-server-client-overlay-div');
  if (overlay) overlay.setAttribute('style', 'display: none');
  if (overlayDiv) overlayDiv.setAttribute('style', 'display: none');
};

export const suppressResizeObserverError = (): void => {
  window.addEventListener(
    'error',
    (e: ErrorEvent) => {
      if (isResizeObserverError(e.message)) {
        e.stopImmediatePropagation();
        e.preventDefault();
        hideWebpackOverlay();
      }
    },
    true,
  );

  window.addEventListener('unhandledrejection', (e: PromiseRejectionEvent) => {
    const reason = e.reason as { message?: string } | undefined;
    if (isResizeObserverError(reason?.message)) {
      e.stopImmediatePropagation();
      e.preventDefault();
      hideWebpackOverlay();
    }
  });
};
